"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _core = require("@material-ui/core");
var useStyles = (0, _core.makeStyles)(function (_ref) {
  var typography = _ref.typography;
  return {
    headingContainer: {
      display: 'flex',
      flexDirection: 'row'
    },
    alertContainer: {
      display: 'flex',
      flexDirection: 'column'
    },
    root: {
      display: 'flex',
      padding: '16px 16px',
      borderRadius: '5px',
      marginBottom: '18px',
      overflowWrap: 'anywhere',
      justifyContent: 'start',
      alignContent: 'center',
      '&.error': {
        backgroundColor: 'rgba(253,237,237)',
        '& .subText': {
          color: '#A62B23',
          fontSize: '13px',
          alignSelf: 'center',
          fontWeight: 600
        },
        '& .text': {
          color: '#A62B23',
          fontSize: '13px',
          alignSelf: 'center',
          fontWeight: typography.fontWeightRegular,
          opacity: '70%'
        },
        '& .icon': {
          color: 'rgba(239, 83, 80)',
          alignSelf: 'center',
          marginRight: '12px'
        }
      },
      '&.warning': {
        backgroundColor: 'rgba(255,244,229)',
        '& .subText': {
          color: '#CF752F',
          fontSize: '13px',
          alignSelf: 'center',
          fontWeight: 600
        },
        '& .text': {
          color: '#CF752F',
          fontSize: '13px',
          alignSelf: 'center',
          fontWeight: typography.fontWeightRegular,
          opacity: '70%'
        },
        '& .icon': {
          color: '#663C00',
          alignSelf: 'center',
          marginRight: '12px'
        }
      },
      '&.info': {
        backgroundColor: '#E9F5FE',
        '& .subText': {
          color: '#3E8CC1',
          fontSize: '13px',
          alignSelf: 'center',
          fontWeight: 600
        },
        '& .text': {
          color: '#3E8CC1',
          fontSize: '13px',
          alignSelf: 'center',
          fontWeight: typography.fontWeightRegular,
          opacity: '70%'
        },
        '& .icon': {
          color: '#0C3C61',
          alignSelf: 'center',
          marginRight: '12px'
        }
      },
      '&.success': {
        backgroundColor: 'rgba(237, 247, 237)',
        '& .subText': {
          color: '#51A869',
          fontSize: '13px',
          alignSelf: 'center',
          fontWeight: 600
        },
        '& .text': {
          color: '#51A869',
          fontSize: '13px',
          alignSelf: 'center',
          fontWeight: typography.fontWeightRegular,
          opacity: '70%'
        },
        '& .icon': {
          color: 'rgba(76, 175, 80)',
          alignSelf: 'center',
          marginRight: '12px'
        }
      }
    },
    closeButton: {
      height: '16px',
      borderRadius: 0,
      color: '#3B82F6',
      marginLeft: '12px',
      alignSelf: 'center',
      padding: '0'
    }
  };
}, {
  name: 'Alert'
});
var _default = useStyles;
exports["default"] = _default;